// extracted by mini-css-extract-plugin
export default {"switchWrapper":"Switcher_switchWrapper__cQbyV","round":"Switcher_round__kwttT"};